import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { latinNumber } from 'helpers/utils/persian';

export default class Time extends React.Component {
  static propTypes = {
    label: PropTypes.node,
    help: PropTypes.node,
    tip: PropTypes.node,
    required: PropTypes.bool,
    placeholder: PropTypes.string
  };

  static defaultProps = {
    placeholder: '17:35'
  };

  state = {
    value: ''
  };

  componentWillMount() {
    const { input } = this.props;
    if (input && input.value) {
      this.setState({
        value: latinNumber(input.value)
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { value } = this.state;
    const { input } = nextProps;
    if (input && input.value && input.value !== value) {
      this.setState({
        value: latinNumber(input.value)
      });
    }
  }

  handleChange = event => {
    const value = latinNumber(event.target.value).replace(/_/g, '0');
    const timeRegex = /^(2[0-3]|1[0-9]|0[0-9]|[^0-9][0-9]):([0-5][0-9]|[0-9])$/;

    if (timeRegex.test(value)) {
      const { input } = this.props;

      if (input && input.onChange) {
        input.onChange(value);
      }

      this.setState({ value });
    }
  };

  render() {
    const { value } = this.state;
    const { label, placeholder, meta, input, handleTimeInputRef } = this.props;
    const hasError = meta && meta.touched && meta.error;

    return (
      <div className={`form-field form-text form-time ${hasError ? 'field-has-error' : ''}`}>
        {label}
        <InputMask
          className="html-input"
          mask="29:59"
          inputRef={handleTimeInputRef}
          formatChars={{
            '2': '[0-2۰-۲]',
            '5': '[0-5۰-۵]',
            '9': '[0-9۰-۹]'
          }}
          {...input}
          placeholder={placeholder}
          onChange={this.handleChange}
          value={value}
        />
      </div>
    );
  }
}
